export class Constants {

    static CURRENT_USER = 'currentUserTrendBotChat';
    static CURRENT_CHANNEL = 'currentUserTrendBotChatChannel';

}